import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import type { EditPromptProps } from './index';

export const EDIT_PROMPT_DIALOG = 'EDIT_PROMPT_DIALOG';

export const closeEditPrompt = () => {
  store?.dispatch(rootUiActions.removeDialog(EDIT_PROMPT_DIALOG));
};

const useEditPromptDialog = () => {
  return (props: Omit<EditPromptProps, 'onClose'>) => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: EDIT_PROMPT_DIALOG,
          type: EDIT_PROMPT_DIALOG,
          props: ImmutableMap({ ...props, onClose: closeEditPrompt }),
        }),
      ),
    );
  };
};

export default useEditPromptDialog;
